const ArrowRight2 = ({ ...props }) => {
  return (
    <svg
      width="53"
      height="48"
      viewBox="0 0 53 48"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 24H49"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M29.2861 2L51.2861 24L29.2861 46"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default ArrowRight2
